import React from 'react';

const MainContext = React.createContext();
MainContext.displayName = 'MainContext';

export default MainContext;
